<template>
  <ul
    :class="[
      `info-list`,
      {
        'info-list--compact' : compact,
      }
    ]"
  >
    <li
      v-for="(section, index) in sections"
      :key="index"

      v-if="!section.hidden"

      class="info-list__item"
    >
      <module-icon
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        :icon="section.icon"
        class="info-list__icon"
        
      />
      <div class="info-list__copy">
        <h3
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h3 mb0 mt0"
          v-html="section.title"
        />
        <p
          v-for="(p, index) in section.copy"
          :key="`p`+ index"

          class="small"

          v-html="p"
        />
      </div>
    </li>
  </ul>
</template>

<script>

//Import
import ModuleIcon from 'components/Icon';
import { mapGetters } from 'vuex';
// Export
export default {
  name: 'module-info-list',

  components: {
    ModuleIcon,
  },

  props: {
    sections: Array,
    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('app', ['org']),
  },
  
};
</script>



// WEBPACK FOOTER //
// InfoList.vue?4f98ba48